define('views/modules/template/edit/calendar/calendar-component/template-calendar',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    // collections
    'collections/template/calendar/template-calendar-days',
    'collections/template/calendar/template-calendar-items',
    // item panels
    'views/modules/template/edit/calendar/activity/activity-panel',
    'views/modules/template/edit/calendar/animated-session/animated-session-panel',
    'views/modules/template/edit/calendar/nutrition/nutrition-panel',
    'views/modules/template/edit/calendar/personal-data/personal-data-panel',
    // views
    'views/modules/calendar/calendar/calendar-component/calendar-component',
    'views/modules/template/edit/calendar/calendar-component/template-calendar-week',
    'views/modules/template/edit/calendar/calendar-component/template-item-duplicate-modal',
    'views/parts/form/button',
    // template
    'text!templates/modules/template/edit/calendar/template-calendar.html',
], function (
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    // collections
    CTemplateCalendarDays,
    CTemplateCalendarItems,
    // item panels
    VTemplateActivityPanel,
    VTemplateSessionPanel,
    VTemplateNutritionPanel,
    VTemplatePersonalDataPanel,
    // views
    VCalendarComponent,
    VTemplateCalendarWeek,
    VTemplateItemDuplicateModal,
    VButton,
    // template
    TTemplateCalendar
) {

    var PANEL_CONSTRUCTOR = {
        activity: VTemplateActivityPanel,
        nutrilog: VTemplateNutritionPanel,
        custom_data: VTemplatePersonalDataPanel,
    };

    var VTemplateCalendar = VCalendarComponent.extend({
        template: TTemplateCalendar,
        daysCollection: CTemplateCalendarDays,
        weekView: VTemplateCalendarWeek,
        itemsCollection: CTemplateCalendarItems,

        regions: _.extend({}, VCalendarComponent.prototype.regions, {
            addWeek: ".add-week-button",
        }),

        initialize: function (opt) {
            VTemplateCalendar.__super__.initialize.call(this, opt);

            _.extend(this, {
                url: {},
                profile: opt.profile,
                role: opt.role,
                group: opt.group
            });

            this.view = _.extend(this.view, {
                addWeek: new VButton({
                    label: "calendar:Add a Blank Week",
                    callback: this.onAddWeekClick,
                    context: this,
                    icon: "fa fa-plus",
                    class: "btn-rounded"
                }),
                itemPanel: {}
            });

            this.listenTo(this.model, {'model:reset': this.onModelReset});

            this.listenTo(this.collection, {
                'update': this.onCollectionUpdate,
                'reset': this.onCollectionReset,
                'add:day:item': this.onAddDayItem,
                'remove:week': this.onRemoveWeek,
            });

            this.listenTo(this.items, {
                'item:destroy': this.onItemDestroy,
                'session:destroy': this.onSessionDestroy,
                'item:click': this.onItemClick,
                'item:move': this.onItemMove,
                'remove': this.onItemRemove,
                'close:details': this.onCloseDetails
            });
        },

        render: function () {
            VTemplateCalendar.__super__.render.apply(this, arguments);
            this.assign(this.view.addWeek, this.zone.$addWeek);
        },

        resetItemsCopy: function () {
            this.itemsCopy = this.items.toJSON({blacklist: true});
            return this;
        },

        getItems: function () {
            return this.items;
        },

        getItemsCopy: function () {
            return this.itemsCopy;
        },

        loadCalendar: function () {
            this.renderCalendar();
            return this;
        },

        resetDays: function () {
            this.collection.reset(this.model.getDays().models);
            return this;
        },

        resetItems: function () {
            var items = this.collection.getAllItems();
            this.items.reset(items);
        },

        removeItemActiveClass: function () {
            this.$el.find('.calendar-item.active').removeClass('active');
            return this;
        },

        removeDayActiveClass: function () {
            this.$el.find('.day.active').removeClass('active');
            return this;
        },

        removeActiveClass: function () {
            this.removeItemActiveClass()
                .removeDayActiveClass();
        },

        getItemPanel: function (type) {
            var panel = this.view.itemPanel[type] = new PANEL_CONSTRUCTOR[type]({
                profile: this.profile,
                group: this.group
            });
            this.listenTo(panel, 'back', this.onCloseDetails);

            panel.onModelReset();
            LayoutState.setInfo(panel, {open: true});

            return panel;
        },

        getSessionPanel: function () {
            var panel = this.view.itemPanel.session;
            if (!panel) {
                panel = this.view.itemPanel.session = new VTemplateSessionPanel({
                    role: this.role,
                    group: this.group
                });
                this.listenTo(panel, 'back', this.onCloseDetails);
            }

            LayoutState.setInfo(panel, {open: true, full: true});
            return panel;
        },

        ////////////
        // events //
        ////////////

        onItemMove: function () {
            this.model.trigger('change');
            this.model.trigger('change:save');
        },

        onModelReset: function (model) {
            this.resetDays()
                .resetItemsCopy();
            LayoutState.toggleInfo(false);
        },

        onCollectionReset: function (collection) {
            this.render();
        },

        onCollectionUpdate: function (collection, options) {
            var added = options.changes.added,
                removed = options.changes.removed,
                templateDays = this.model.getDays();

            if (added && added.length > 0) {
                templateDays.set(added, {remove: false});
                this.addWeek(added);
            }

            if (removed && removed.length > 0) {
                templateDays.remove(removed);
            }
        },

        onAddWeekClick: function () {
            this.collection.addBlankWeek();
        },

        onDuplicateItem: function (model) {
            var view = this.view,
                duplicate = view.duplicate;

            if (model.getType() === 'animated') {
                var sessionId = model.get('session'),
                    sessionItems = this.items.where({type: 'animated', session: sessionId});
                duplicate = view.duplicate = new VTemplateItemDuplicateModal({sessionItemsToDuplicate: sessionItems});
            } else {
                duplicate = view.duplicate = new VTemplateItemDuplicateModal();
            }

            duplicate.setTemplateId(this.model.getSessions());
            duplicate.setModel(model).render();
        },

        onCloseDetails: function () {
            this.removeActiveClass();
            LayoutState.toggleInfo(false);
        },

        onItemClick: function (model) {
            var type = model.getType(),
                panel;

            if (type === 'animated') {
                var session = this.model.getSessions().get(model.get('session'));
                panel = this.getSessionPanel();
                panel.setModel(session);
            } else {
                panel = this.getItemPanel(type);
                panel.setModel(model);
            }

            this.removeActiveClass();
        },

        onAddDayItem: function (day, type) {
            var panel;

            panel = type === 'animated' ? this.getSessionPanel() : this.getItemPanel(type);
            panel.resetModel({dayId: day.id});

            this.removeActiveClass();
        },

        onItemDestroy: function (model) {
            this.items.remove(model);
            if (model.get('type') === "animated") {
                var weeks = [];
                var weekNumber = model.get('week');
                var session = this.model.getSessions().findWhere({_id: model.get('session')});

                var itemsInSession = this.items.where({session: model.get('session')});
                var filteredItems = this.items.filter(function (item) {
                    return _.isNaN(item.get('dayId'));
                });

                if (itemsInSession.length > 0 && filteredItems.length === itemsInSession.length || itemsInSession.length === 1 && _.isNaN(itemsInSession[0].get('dayId'))) {
                    this.onSessionDestroy(model);
                    return;
                }

                if (_.isUndefined(session)) {
                    this.onCloseDetails();
                    return;
                }

                this.items.models.forEach(function (item) {
                    if (!_.isNaN(item.get('dayId')) && item.get('session') === model.get('session')) {
                        weeks.push(item);
                    }
                });

                session.set({num_weeks: weeks.length});

                session.get('exercises').forEach(function (exercise) {
                    exercise.weeks.splice(weekNumber, 1);
                });

                this.collection.models.forEach(function (model) {
                    model.items.forEach(function (item) {
                        if (item.get('session') === session.get('_id') && item.get('week') > weekNumber) {
                            item.set({week: item.get('week') - 1});
                        }
                    });
                });
            }

            this.onCloseDetails();
            this.model.trigger('change:save');
        },

        onItemRemove: function (model) {
            var sessionId = model.get('session'),
                sessionItems = this.items.where({type: 'animated', session: sessionId});

            if (model.getType() === 'animated' && !sessionItems.length) {
                this.model.getSessions().remove(sessionId);
            }
            this.model.trigger('change');
        },

        onSessionDestroy: function (model) {
            var sessionId = model.get('session'),
                sessionItems = this.items.where({type: 'animated', session: sessionId});

            this.model.getSessions().remove(sessionId);
            this.items.remove(sessionItems);
            this.model.trigger('change:save');
        },

        onRemoveWeek: function (collection) {
            this.collection.remove(collection.models);
            this.resetItems();
            this.model.trigger('change');
        },

        onSessionEdit: function (model) {
            var panel = this.getSessionPanel();
            panel.setModel(model);
        },

        onSessionUpdate: function (session, origin, duplicate) {
            //if (origin.indexOf('calendar') > -1) return; //Bug: Add multiple items to this session if an exercice is deleted from the calendar.
            var items = this.items,
                model = this.model;
            items.updateSession(session, model);
            model.trigger('change');
            if (duplicate !== true) {
                this.model.trigger('change:save');
            }
            this.removeActiveClass();
        },

        onItemUpdate: function (model) {
            VTemplateCalendar.__super__.onItemUpdate.call(this, model);
            this.model.trigger('change');
            this.model.trigger('change:save');
            this.removeActiveClass();
        },

    });

    return VTemplateCalendar;
});

